import { useCallback } from 'react';

import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { useHeader } from '@app/providers';

export const useCertificatesPageHeader = () => {
  const {
    userAccessRights: { Clients },
  } = useNewUserAccessRights();

  const { isMobile } = useWindowSize();
  const { header } = useHeader();

  // Открытие модалки публикует страница реестра через HeaderContext
  const openCreateModal = useCallback(() => {
    const { openCertificateModal } = header;

    if (typeof openCertificateModal === 'function') {
      openCertificateModal();
    }
  }, [header]);

  return {
    canCreate: Boolean(Clients?.IsEdit),
    isMobile,
    openCreateModal,
  };
};
